// extracted by mini-css-extract-plugin
export var centerText = "_dq-8";
export var container = "_dq-0";
export var doughnutContainer = "_dq-7";
export var legend = "_dq-a";
export var legendItemColorDisplay = "_dq-b";
export var legendItemLabel = "_dq-d";
export var legendItemValue = "_dq-c";
export var lg = "_dq-5";
export var maxWidth = "_dq-9";
export var md = "_dq-4";
export var responsive = "_dq-6";
export var sm = "_dq-3";
export var xs = "_dq-2";
export var xxs = "_dq-1";